import React from 'react'
import ReactDOM from 'react-dom'
import localForage from 'localforage'
import createStore from './store/createStore'

import './styles/main.css'

import times2theme from './styles/times2-theme'

import { MuiThemeProvider } from '@material-ui/core/styles'

// Store Initialization
// ------------------------------------
localForage.getItem('times2-state').then(initialState => {
	const store = createStore(initialState !== null ? initialState : undefined)

	store.subscribe(() => {
		// Store a new initial state for next load. This should look like the
		// general initial state, but also including any data you want to cache
		const state = store.getState();
		localForage.setItem('times2-state', {
			reference: state.reference
		});
	})

	// Render Setup
	// ------------------------------------
	const MOUNT_NODE = document.getElementById('root')

	let render = () => {
	  const App = require('./components/App').default
	  const routes = require('./routes/index').default(store)

	  ReactDOM.render(
	    <MuiThemeProvider theme={times2theme}>
	      <App store={store} routes={routes} />
	    </MuiThemeProvider>,
	    MOUNT_NODE
	  )
	}

	// Development Tools
	// ------------------------------------
	if (__DEV__) {
	  if (module.hot) {
	    const renderApp = render
	    const renderError = (error) => {
	      const RedBox = require('redbox-react').default

	      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE)
	    }

	    render = () => {
	      try {
	        renderApp()
	      } catch (e) {
	        console.error(e)
	        renderError(e)
	      }
	    }

	    // Setup hot module replacement
	    module.hot.accept([
	      './components/App',
	      './routes/index',
	    ], () =>
	      setImmediate(() => {
	        ReactDOM.unmountComponentAtNode(MOUNT_NODE)
	        render()
	      })
	    )
	  }
	}

	// Let's Go!
	// ------------------------------------
	if (!__TEST__) render()
})



// WEBPACK FOOTER //
// ./src/main.js